import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebounce } from 'use-debounce';
import { RootState, FilterType, OptionsState } from './types';
import { buildTransformations, generateSearchExpression } from './services/widget-service';
import { INLINE_CONTAINTER } from './constants/general';

const selectOptions = (state: RootState) => state.options;
export const useOptions = () => useSelector(selectOptions);

export const selectConfiguration = (options: OptionsState) => {
  const configuration: OptionsState = {
    removeHeader: options.removeHeader,
    maxFiles: options.maxFiles,
    insertCaption: options.insertCaption,
    inlineContainer: options.inlineMode ? INLINE_CONTAINTER : '',
    defaultTransformations: buildTransformations(options.transformations, options.customTransformations, options.areCustomTransformationsEnabled),
  };

  if (options.filterSelection === FilterType.Folder && options.folderName) {
    configuration.folder = {
      path: options.folderName,
    };
  } else if (options.filterSelection === FilterType.Search && (options.isSearchFilterByAsset || options.isSearchFilterByCustomExpression)) {
    configuration.search = {
      expression: generateSearchExpression({ ...options }),
    };
  }
  return configuration;
};

export const useWidgetConfiguration = () => {
  const [conf, setConf] = useState({});
  const options = useOptions();
  const [optionsDB] = useDebounce(options, 1000);

  useEffect(() => {
    setConf(selectConfiguration(optionsDB));
  }, [optionsDB]);
  return conf;
};

const selectAuth = (state: RootState) => state.auth;
export const useAuth = () => useSelector(selectAuth);

const selectMedia = (state: RootState) => state.media;
export const useMedia = () => useSelector(selectMedia);

const selectConsoleResponse = (state: RootState) => state.consoleResponse;
export const useConsoleResponse = () => useSelector(selectConsoleResponse);
